<template>
  <div style="margin-bottom: 20px">
    <div>
      <el-button
        v-if="widget.options.isUpdate"
        type="primary"
        icon="el-icon-upload"
        style="margin-right: 10px"
        >上传签名照</el-button
      >
      <span v-if="widget.options.isUpdate">或</span>
      <el-button type="primary" icon="el-icon-edit">手写签名 </el-button>
      或
      <el-button style="margin-right: 10px" type="primary" icon="el-icon-edit"
        >选择签名</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ['widget'],
}
</script>

<style></style>
